module.exports = __webpack_public_path__ + "26af88e42274407d6776af85617e4acc.pdf";